import { Button } from 'react-bootstrap';

interface TaskFilterFooterProps {
    resetLabel: string;
    applyLabel: string;
    onReset: () => void;
    onApply: () => void;
}

const TaskFilterFooter = ({ resetLabel, applyLabel, onReset, onApply }: TaskFilterFooterProps) => (
    <div className="p-3 offcanvas-footer off-filter-footer">
        <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" onClick={onReset}>
                {resetLabel}
            </Button>
            <Button variant="info" className="min100px" onClick={onApply}>
                {applyLabel}
            </Button>
        </div>
    </div>
);

export default TaskFilterFooter;
